var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { ApplicationContext } from '../../../../ApplicationContext';
import LabelOption from './LabelOption';
import LabelOverlay from '../../../pages/Labels/LabelOverlay';
import Signals from '../../../../signals/Signals';
/**
 *
 */
var LabelSearch = /** @class */ (function (_super) {
    __extends(LabelSearch, _super);
    /**
     *
     * @param props
     */
    function LabelSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = _this.onChange.bind(_this);
        _this.onUpdate = _this.onUpdate.bind(_this);
        _this.onAddLabel = _this.onAddLabel.bind(_this);
        _this.onToggleEdit = _this.onToggleEdit.bind(_this);
        _this.state = { isVisible: false };
        return _this;
    }
    /**
     *
     * @return {*}
     */
    LabelSearch.prototype.render = function () {
        var _a = this.props, name = _a.name, intl = _a.intl, className = _a.className;
        var isVisible = this.state.isVisible;
        var classes = classNames({ 'w-100': isVisible, 'mt-3': isVisible }) + ' ' + className;
        return (React.createElement("div", { className: "label-search d-flex justify-content-end align-items-center ".concat(classes) },
            isVisible &&
                React.createElement("div", { className: "label-search__input-wrapper w-100" },
                    React.createElement(Select, { className: "form-control select2", classNamePrefix: "select2", name: name, placeholder: intl.formatMessage({ id: 'label.search' }), noOptionsMessage: function () {
                            return intl.formatMessage({ id: 'label.noresults' });
                        }, components: { Option: LabelOption }, value: null, isSearchable: true, options: this._createOptions(), onChange: this.onChange, getOptionValue: function (option) { return "".concat(option['label']); }, isOptionDisabled: function (option) { return option.value == null; } })),
            React.createElement("div", { className: "d-flex justify-content-end align-items-start" }, isVisible ?
                React.createElement("button", { className: "btn btn-link btn-sm", onClick: this.onToggleEdit },
                    React.createElement("i", { className: "fe fe-x" })) :
                React.createElement("button", { className: "btn btn-link btn-sm", onClick: this.onToggleEdit },
                    React.createElement("i", { className: "fe fe-settings" })))));
    };
    /**
     *
     */
    LabelSearch.prototype.onAddLabel = function () {
        var labelCollection = this.context.labelCollection;
        Signals.ShowOverlay.dispatch(React.createElement(LabelOverlay, { labelCollection: labelCollection, onUpdate: this.onUpdate }));
    };
    /**
     *
     * @param option
     */
    LabelSearch.prototype.onChange = function (option) {
        if (this.props.onChange) {
            this.props.onChange(option.model);
        }
    };
    /**
     *
     * @param labelModel
     */
    LabelSearch.prototype.onUpdate = function (labelModel) {
    };
    /**
     *
     */
    LabelSearch.prototype.onToggleEdit = function () {
        var _this = this;
        this.setState({ isVisible: !this.state.isVisible }, function () {
            if (_this.props.onVisibility) {
                _this.props.onVisibility(_this.state.isVisible);
            }
        });
    };
    /**
     *
     * @return {{label: (*|string), value: *}[]|Array}
     * @private
     */
    LabelSearch.prototype._createOptions = function () {
        var exclude = this.props.exclude;
        var labelCollection = this.context.labelCollection;
        var labels = labelCollection.list.concat([]);
        var _loop_1 = function (i) {
            exclude.forEach(function (model) {
                if (labels[i] && model) {
                    if (model.id === labels[i].id) {
                        labels.splice(i, 1);
                    }
                }
            });
        };
        for (var i = labels.length - 1; i >= 0; i--) {
            _loop_1(i);
        }
        var options = labels.map(function (labelModel) {
            return {
                value: labelModel.id,
                label: labelModel.name,
                model: labelModel
            };
        });
        options.unshift({ value: null, label: null, model: null });
        return options;
    };
    LabelSearch.defaultProps = {
        className: '',
        exclude: [],
        placeholder: 'Selecteer label'
    };
    LabelSearch = __decorate([
        observer
    ], LabelSearch);
    return LabelSearch;
}(React.Component));
LabelSearch.contextType = ApplicationContext;
export default injectIntl(LabelSearch);
